module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-pl-PL.583eff61.jpg";